import MarkdownParser, { interpretLink } from './MarkdownParser';

export default MarkdownParser;
export { interpretLink };
